import { render, staticRenderFns } from "./ProviderInfo.vue?vue&type=template&id=4dfff268&scoped=true"
import script from "./ProviderInfo.vue?vue&type=script&lang=js"
export * from "./ProviderInfo.vue?vue&type=script&lang=js"
import style0 from "./ProviderInfo.vue?vue&type=style&index=0&id=4dfff268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfff268",
  null
  
)

export default component.exports